import { GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/amafeecodes'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

const API = {
  ...baseFunctions,
}

export default API
